<div style="width: 100%;">
    <div *ngIf="task" class="wrapper">
        <div class="header">
            <h2>{{ task.typeStr }}</h2>
            <div class="control-buttons">
                <app-task-view [task]="task" [showCheckStatus]="false"
                    [showRecalculateButton]="!task.isIndexing && !task.isArchived" [showStatus]="false"
                    [showReindexButton]="!task.isIndexing" [showTaskTabButton]="false"
                    [showStartStopButton]="!task.isArchived"
                    [showClearThreadsButton]="task.canStop || task.hasActiveThreads"
                    (deleteProcess)="deleteProcess($event)" class="task-view" [dark]="false">
                </app-task-view>
            </div>
        </div>

        <div style="grid-column-start: 1; grid-column-end: 3; grid-area: main;">
            <div *ngIf="task">
                <h3 class="md-subhead">Zoning Code <app-process-small-spinner class="zoning-code-spinner"
                        *ngIf="isZoningCodeLoading" [isVisible]="true">
                    </app-process-small-spinner>
                </h3>
                <div class="mat-typography" *ngIf="!isZoningCodeLoading">
                    <app-process-status-row [process]="task"></app-process-status-row>
                    <p>Name: {{zoningCode?.Name}}
                    </p>
                    <p *ngIf="zoningCode?.Status !== undefined && (task.isIndexing || task.isCalculation)">Zoning Code
                        Status (current): {{getPrettyZCStatus(zoningCode?.Status)}}
                    </p>
                    <p *ngIf="task?.zoningCodeStatus !== undefined && (task.isIndexing || task.isCalculation)">Zoning
                        Code Status (at process start): {{getPrettyZCStatus(task?.zoningCodeStatus)}}
                    </p>
                    <p>Actual version: {{zoningCode?.ActualVersion}}</p>
                    <p>Gridics Id: {{zoningCode?.GridicsId}}</p>
                    <p *ngIf="task.zcVersionId">Version Id : {{task.zcVersionId }}</p>
                </div>
                <app-data-source-category-view
                    [dataSourceCategories]="task.dataSourceCategories"></app-data-source-category-view>
                <div class="mat-typography" style="margin-top: 15px;">
                    <p>Send data to Solr: {{task?.syncSolrData?'Yes':'No'}}
                    </p>
                </div>
                <div *ngIf="task['saveRawIds'] !== undefined" class="mat-typography" style="margin-top: 15px;">
                    <p>Save PR Ids for investigation: {{task?.saveRawIds?'Yes':'No'}}
                    </p>
                </div>
            </div>
        </div>

        <div style="grid-column-start: 2; grid-column-end: 2; grid-row-start: 2; grid-row-end: 2; grid-area: calcStat;">
            <h3 *ngIf="task.isProcess" class="md-subhead">{{ task.typeStr }} statistic</h3>
            <div class="mat-typography content">
                <app-process-statistic-section [process]="task"></app-process-statistic-section>
            </div>
        </div>
        <div style="grid-column-start: 1; grid-column-end: 1; grid-row-start: 3; grid-row-end: 3; grid-area: perf;">
            <div *ngIf="task.performance" style="padding: 0px 10px 0px 0px;">
                <h3 class="md-subhead">Performance statistic</h3>
                <app-task-performance-details [task]="task" class="mat-typography"></app-task-performance-details>
            </div>

            <app-prs-bunch-size-slider [task]="task" *ngIf="!task.isArchived">
            </app-prs-bunch-size-slider>

            <app-process-messages-section [process]="task"></app-process-messages-section>
        </div>

        <div style="grid-column-start: 1; grid-column-end: 3; grid-row-start: 4; grid-row-end: 4; grid-area: cache;">
            <div *ngIf="task.cacheStatistic">
                <h3 class="md-subhead">Cache statistic</h3>
                <app-process-cache-statistic [cacheStatistic]="task.cacheStatistic"></app-process-cache-statistic>
            </div>
        </div>

        <div
            style="grid-column-start: 2; grid-column-end: 2; grid-row-start: 3; grid-row-end: 3; grid-area: statByStatus;">
            <app-process-stats-by-status-section [process]="task"
                [showRatio]="true"></app-process-stats-by-status-section>
        </div>

        <div class="charts" *ngIf="this.task.isCalculation"
            style="grid-column-start: 3; grid-column-end: 3; grid-row-start: 2; grid-row-end: 2; grid-area: chart1;">
            <div *ngIf="ratiosByStatuses.length" style="height: 100%;">
                <h3>All Property Records By Statuses</h3>
                <universal-pie-chart [ratios]="ratiosByStatuses" [properties]="propertiesByStatuses"
                    style="height: calc(100% - 50px); display:block;">
                </universal-pie-chart>
            </div>
        </div>

        <div class="charts" *ngIf="this.task.isCalculation"
            style="grid-column-start: 3; grid-column-end: 3; grid-row-start: 3; grid-row-end: 3; grid-area: chart2;">
            <div class="uncalculated-ratio-chart" style="height: 100%;" *ngIf="totalRatios.length">
                <h3>Calculation Results Statuses</h3>
                <universal-pie-chart [ratios]="totalRatios" [properties]="totalProperties"
                    style="height: calc(100% - 50px); display:block;">
                </universal-pie-chart>
            </div>
        </div>
    </div>

    <mat-tab-group class="mat-elevation-z0" #tabs (selectedTabChange)="tabChanged($event)" mat-stretch-tabs="false">
        <mat-tab *ngIf="!task.isIndexing" label="Property Records in Progress">
            <div>
                <app-pr-threads-list [prThreadsData]="task.prThreadsData">
                </app-pr-threads-list>
            </div>
        </mat-tab>

        <mat-tab *ngIf="!task.isIndexing" label="Monitoring">
            <div class="chart-tool-bar">
                <app-update-process-perf-stat-button [process]="task"
                    [updateDataHandler]="updateDataHandler.bind(this)"></app-update-process-perf-stat-button>
            </div>
            <div *ngIf="isMonitoringTabActive" style="overflow: overlay; padding-top: 10px;">
                <mat-grid-list cols="2" rowHeight="365">
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['GISCalcTimeMs','DataLoadTimeMs','TransferTimeMs','SaveToDBTimeMs']"
                                [fieldsLabels]="['GIS Calculation Time','GIS Data Load Time (Service)','Transfer Time','Save To DB Time']"
                                [title]="'Calculation Time Structure (Ms)'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['AVGGISCalcTimeMs','AVGDataLoadTimeMs','AVGTransferTimeMs','AVGSaveToDBTimeMs']"
                                [fieldsLabels]="['GIS Calculation Time','GIS Data Load Time (Service)','Transfer Time','Save To DB Time']"
                                [title]="'Average Calculation Time Structure (Ms)'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['GAPIDataLoadDuration']" [fieldsLabels]="['GAPI Data Load Duration']"
                                [title]="'GAPI Data Load Duration (s)'"
                                [colors]="['#00E396']"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['WaitForDataDuration']" [fieldsLabels]="['Wait For Data Time']"
                                [title]="'Wait For Data Time (ZAPI and Service Idle time) (s)'"
                                [colors]="['#feb019']"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CRsPerHour']" [fieldsLabels]="['Calculation Results per Hour']"
                                [title]="'Calculation Results per Hour'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['AVGCRsPerHour']" [fieldsLabels]="['Calculation Results per Hour']"
                                [title]="'Average Calculation Results per Hour'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CRsInPeriod']" [fieldsLabels]="['Calculation Results per Minute']"
                                [title]="'Calculation Results per Minute'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['TotalCRs']" [fieldsLabels]="['Total Calculation Results']"
                                [title]="'Total Calculation Results'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CRsPerHourPerThread']"
                                [fieldsLabels]="['Calculation Results per Hour per Thread']"
                                [title]="'Calculation Results per Hour per Thread'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['ThreadsCount']" [fieldsLabels]="['Threads Count']"
                                [title]="'Threads Count'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['TotalPRsInProgress']"
                                [fieldsLabels]="['Property Records in Progress']"
                                [title]="'Property Records in Progress'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['BunchSize']" [fieldsLabels]="['Property Records Bunch Size']"
                                [title]="'Property Records Bunch Size'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['DataSetsCached']" [fieldsLabels]="['Data Sets Cached']"
                                [title]="'Data Sets Cached'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CachingIterationsCount']"
                                [fieldsLabels]="['Number of Caching Iterations']"
                                [title]="'Number of Caching Iterations'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CachedPropertyRecordsCount','ReceivedPropertyRecordsCount','MissedPropertyRecordsCount']"
                                [fieldsLabels]="['Cache','GAPI','Not found']"
                                [colors]="['#008FFB', '#00E396', '#ff4560']"
                                [title]="'Property Records source'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CachedAbuttingPRsCount','ReceivedAbuttingPRsCount','MissedAbuttingPRsCount']"
                                [fieldsLabels]="['Cache','GAPI','Not found']"
                                [colors]="['#008FFB', '#00E396', '#ff4560']"
                                [title]="'Abutting Property Records source'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CachedStreetsCount','ReceivedStreetsCount','MissedStreetsCount']"
                                [fieldsLabels]="['Cache','GAPI','Not found']"
                                [colors]="['#008FFB', '#00E396', '#ff4560']"
                                [title]="'Streets source'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CachedPRTagsCount','ReceivedPRTagsCount','MissedPRTagsCount']"
                                [fieldsLabels]="['Cache','GAPI','Not found']"
                                [colors]="['#008FFB', '#00E396', '#ff4560']"
                                [title]="'Property Records Tags source'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>

                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CacheSize']" [fieldsLabels]="['Cached Items']"
                                [title]="'Cached Items'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="labeled-chart-container">
                            <app-universal-area-chart [data]="processCalculationStatistics"
                                [fieldsToShow]="['CalculatedCacheSizeBytes']"
                                [fieldsLabels]="['Calculated Cache Size Bytes']"
                                [title]="'Calculated Cache Size (Kb)'"></app-universal-area-chart>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
        </mat-tab>

        <mat-tab label="Cache" *ngIf="task?.cacheStatistic || task?.gisDataCacheStatistic">
            <div style="padding: 10px;">
                <p>GAPI data cache used: <b>{{ task?.useGAPIDataCache ? 'Yes' : 'No' }}</b></p>
                <app-process-gis-data-cache-statistic
                    [gisDataCacheStatistic]="task.gisDataCacheStatistic"></app-process-gis-data-cache-statistic>
                <app-process-gis-data-cache-iterator-statistic
                    [cacheIteratorStatistic]="task.cacheStatistic"></app-process-gis-data-cache-iterator-statistic>
            </div>
        </mat-tab>

        <mat-tab label="Statistic">
            <div *ngIf="task?.solrGroupIdsStatistic" style="padding: 10px;">
                <h3 class="md-subhead">Synchronization with Solr - <app-solr-operations-status
                        [data]="task?.solrGroupIdsStatistic"></app-solr-operations-status></h3>
                <app-solr-group-ids-data-statistic [data]="task?.solrGroupIdsStatistic">
                </app-solr-group-ids-data-statistic>
            </div>
            <div *ngIf="task?.zoningCodeStatistic" style="padding: 10px;">
                <h3 class="md-subhead">Average performancec</h3>
                <app-zc-performance-details-view [zcStatistic]="task?.zoningCodeStatistic">
                </app-zc-performance-details-view>
            </div>
            <div *ngIf="task?.isIndexing">
                <div style="padding: 10px;">
                    <h3 class="md-subhead">Create</h3>
                    <app-bulk-operation-statistic
                        [data]="task.indexationStatistic.create"></app-bulk-operation-statistic>
                    <h3 class="md-subhead">Update</h3>
                    <app-bulk-operation-statistic
                        [data]="task.indexationStatistic.update"></app-bulk-operation-statistic>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Events">
            <div class="chart-tool-bar">
                <!-- <app-events-stat-hint-icon style="margin-right: 10px;" hintIconClass="process-view-stat-hint-icon"
                    placement="right"></app-events-stat-hint-icon> -->
                <app-events-stat-component [statistic]="task?.eventsStat" [stateEnv]="task?.state"
                    [hideRefreshButton]="true" style="width: 100%;"></app-events-stat-component>
                <app-update-system-events-list-button class="inline-action-button" [stateEnv]="task?.state"
                    [parentId]="task?.id" [parentType]="systemEventParentType.PROCESS"
                    [updateDataHandler]="updateEventsList.bind(this)"></app-update-system-events-list-button>
            </div>
            <app-process-events-list [eventsList]="eventsList"></app-process-events-list>
        </mat-tab>
    </mat-tab-group>
</div>